const Navbar = () => {
  const [isActive, setIsActive] = useState("dashboard");
  let location = useLocation();

  const navCategory_1 = [
    { id: "dashboard", to: "/home", icon: "ti ti-home", label: "Home" },
    {
      id: "organizations",
      to: "/organizations",
      icon: "ti ti-building",
      label: "Organizations",
    },
    {
      id: "applications",
      to: "/applications",
      icon: "ti ti-layout",
      label: "Applications",
    },
  ];

  const navCategory_2 = [
    { id: 'templates', to: '/eTemplates', icon: 'ti ti-template', label: 'E-Mail Templates' },
    {
      id: "settings",
      to: "/settings",
      icon: "ti ti-settings",
      label: "Settings",
    },
  ];

  return (
    <nav className="sidebar-nav scroll-sidebar" data-simplebar>
      {/* first catagory of navs */}
      <Nav as="ul" id="sidebarnav">
        {navCategory_1.map((item) => (
          <Nav.Item as="li" key={item.id} className="sidebar-item">
            <Nav.Link
              as={Link}
              id={item.id}
              to={item.to}
              className={classNames("sidebar-link", "nav-link", {
                active: location.pathname === item.to,
              })}
              onClick={() => setIsActive(item.id)}
            >
              <span>
                <i className={item.icon} />
              </span>
              <span className="hide-menu">{item.label}</span>
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      {/* seperator */}
      <hr className="text-white" />
      {/* second catagory of navs */}
      <Nav as="ul" id="sidebarnav" className="flex-column">
        {navCategory_2.map((item) => (
          <Nav.Item as="li" key={item.id} className="sidebar-item">
            <Nav.Link
              as={Link}
              id={item.id}
              to={item.to}
              className={classNames("sidebar-link", "nav-link", {
                active: location.pathname === item.to,
              })}
              onClick={() => setIsActive(item.id)}
            >
              <span>
                <i className={item.icon} />
              </span>
              <span className="hide-menu">{item.label}</span>
            </Nav.Link>
          </Nav.Item>
        ))}
        {/* <hr className="text-white" /> */}
      </Nav>
    </nav>
  );
};

export default Navbar;
